/*! Copyright (c) Safe As Milk. All rights reserved. */
class SearchForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector("form");
    }
    connectedCallback() {
        if (this.hasAttribute("add-recent-search-on-load")) this.addFormStateToRecentSearches();
        if (this.hasAttribute("data-fetch-related-search-terms")) this.fetchRelatedSearchTerms();
    }
    static addRecentSearch(query, uri) {
        if (!query || !uri) return;
        const getUniqueListBy = (arr, key) => [ ...new Map(arr.map((item => [ item[key], item ]))).values() ];
        let recentSearches = [ {
            query: query,
            uri: uri
        } ];
        const recentSearchesStoredString = localStorage.getItem("recentSearches");
        if (recentSearchesStoredString) {
            const recentSearchesStored = JSON.parse(recentSearchesStoredString);
            const combinedSearches = [ ...recentSearchesStored, ...recentSearches ];
            recentSearches = getUniqueListBy(combinedSearches.reverse(), "query").reverse();
            if (recentSearches.length > 5) {
                recentSearches = recentSearches.slice(-5);
            }
        }
        localStorage.setItem("recentSearches", JSON.stringify(recentSearches));
        document.querySelectorAll("recent-searches").forEach((el => el.update()));
    }
    addFormStateToRecentSearches() {
        if (!this.form) return;
        const form = new FormData(this.form);
        const search = new URLSearchParams(form);
        const formAction = new URL(`${window.location.origin}${this.form.getAttribute("action")}`);
        const formActionOrigin = window.location.origin;
        const formActionPath = formAction.pathname;
        const formActionSearch = formAction.searchParams;
        const combinedSearch = new URLSearchParams({
            ...Object.fromEntries(formActionSearch),
            ...Object.fromEntries(search)
        });
        SearchForm.addRecentSearch(form.get("q"), `${formActionOrigin}${formActionPath}?${combinedSearch.toString()}`);
    }
    fetchRelatedSearchTerms() {
      const terms = this.form.querySelector('input[name="q"]').value;

      if (terms.length > 0) {
        fetch(`${window.Shopify.routes.root}search/suggest.json?q=${terms}&resources[type]=query&resources[options][unavailable_products]=hide&resources[options][fields]=title,body,tag,product_type,variants.title,vendor`)
          .then((response) => response.json())
          .then((suggestions) => {
            const searchSuggestions = suggestions.resources.results.queries;

            if (searchSuggestions.length > 0) {
              const relatedSearches = document.querySelector('.js-related-searches');

              if (!!(relatedSearches)) {
                searchSuggestions.forEach((suggestion) => {
                  relatedSearches.insertAdjacentHTML('beforeend', `<a href="${suggestion.url}">${suggestion.text}</a>`);
                });
              }
            }
          })
          .catch((error) => {
            console.error('Error fetching related search terms:', error);
          });
      }
    }
}

customElements.define("search-form", SearchForm);

/**
 * Fetches the recently viewed products when available
 */

document.addEventListener('DOMContentLoaded', () => {
  const mainContent = document.querySelector('.js-main-content');
  const recentlyViewedProducts = document.querySelector('.js-recently-viewed');

  if (!!(mainContent) && !(recentlyViewedProducts)) {
    const observer = new MutationObserver((mutations, obs) => {
      const recentlyViewed = document.querySelector('.js-recently-viewed');

      if (!!(recentlyViewed)) {
        const script = recentlyViewed.nextElementSibling;

        if (!!(script) && script.classList.contains('js-recently-viewed-products-script')) {
          fetch(script.src)
            .then((response) => response.text())
            .then((data) => {
              const newScript = document.createElement('script');

              newScript.textContent = data;
              newScript.type = 'module';
              script.remove();
              recentlyViewed.parentElement.appendChild(newScript);
              obs.disconnect();
            })
            .catch((error) => {
              console.error('Error fetching recently viewed products:', error);
            });
        }
      }
    });

    observer.observe(mainContent, {
      childList: true,
      subtree: true
    });
  }
});
//# sourceMappingURL=search-form.js.map
